import React from 'react'

class Header extends React.Component {
  render() {
    return (
      <section id="header">
        <div className="inner">
          <span className="icon major fa-cloud"></span>
          <h1>
            Welcome to <strong>DEPSI</strong>
          </h1>
          <h1>
            web data extraction platform.
          </h1>
          {/* <ul className="actions">
            <li>
              <a href="https://www.app.depsi.com" className="button scrolly">
                Try it!
              </a>
            </li>
          </ul> */}
        </div>
      </section>
    )
  }
}

export default Header
